<template>
  <div style="width:1180px;margin:50px auto;background-color:#FFF;">
    <!-- Modal -->
    <div class="modal fade" id="myModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
      aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">Message</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <template v-for="(errMsg, index) in errMsgs">
              <div v-bind:key="index">
                {{ errMsg }}
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button v-show="modalType == 'error'" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button v-show="modalType == 'toMainPage'" type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="isMainPage = true" >Close</button>
          </div>
        </div>
      </div>
    </div>

    <!-- loading -->
    <div class="loading" v-show="pageLoading">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div v-if="isMainPage && isSSO == true">
      <div style="margin:20px 0px;text-align: left;font-weight: 510;font-size: 22px;line-height: 21px;">SMS / MMS 範本
        <div class="infoDiv" data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="right"
          title="若此範本已使用在已啟動的Journey內，再修改此範本的文案，不會同步更新Journey內的範本">
          <font-awesome-icon icon="fa-solid fa-circle-info" style="font-size: 13px;margin-bottom: 2px;" />
        </div>
      </div>

      <el-tabs v-model="selectedMsgType" @tab-click="switchMsgType()">
        <el-tab-pane label="SMS" name="SMS" style="font-size: large;">
          <div v-if="selectedMsgType == 'SMS'">
            <!-- <input class="" type="text" style="float:left;width:60%;height:38px;" v-model="campaignName"/> -->
            <!-- <el-input type="text" v-model="campaignName" placeholder="搜尋..." prefix-icon="el-icon-search" style="float:left;width: 80%"></el-input> -->
            <form class="d-flex" style="margin: 10px 0px 10px 3px;" onkeypress="return event.keyCode != 13">
              <div class="d-flex flex-row position-relative" style="width:50%;">
                <input type="text" class="form-control" id="example-search-input" v-model="searchName"
                  placeholder="請輸入 SMS 範本名稱" v-on:keyup="keyUpFun">
                <button class="btn border-0 position-absolute end-0" type="button" v-on:click="getListData">
                  <font-awesome-icon icon="a-solid fa-magnifying-glass" />
                </button>
              </div>
              <span style="width:36%;">&nbsp;</span>
              <button type="button" class="btn btn-light"
                style="width:15%;background-color:#fff;color:#2C70CB;border: 1px solid #cccccc;font-weight: 500;"
                v-on:click="selectModel('新增')">+ 新增 SMS 範本</button>
            </form>
            <div style="height:calc(100% - 20px);padding: 10px 0px;">
              <div id="tableList" style="height: calc(100%);">
                <el-table class="elTable" v-loading="listLoading" v-bind:data="showSmsList" element-loading-text="Loading"
                  v-bind:header-cell-style="{ background: '#FFF', color: '#606266', borderBottom: '1px solid #CCCCCC' }"
                  min-height="100%" style="width:100%;height: 100%;overflow: auto;">
                  <el-table-column prop="AutoName" label="SMS 範本名稱" min-width="55%">
                    <template slot-scope="sms">
                      <span v-text="sms.row.AutoName">
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="Message" label="則數" min-width="15%">
                    <template slot-scope="sms">
                      <span v-text="sms.row.Message">
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="CreatedAt" label="建立日期" min-width="15%">
                    <template slot-scope="sms">
                      <span v-text="sms.row.CreatedAt">
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="動作" min-width="15%">
                    <template slot-scope="scope">
                      <el-button v-on:click="selectModel('複製', scope.row)" type="text" size="small">Copy</el-button>
                      <el-button v-on:click="selectModel('編輯', scope.row)" type="text" size="small">Edit</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <el-pagination v-on:size-change="handleSizeChange1" v-on:current-change="handleCurrentChange1"
                v-bind:current-page="currentListPage" v-bind:pager-count="11" v-bind:total="total"
                layout="->, prev, pager, next" style="height:40px;padding:10px 0px 0px 0px;">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="MMS" name="MMS">
          <div v-if="selectedMsgType == 'MMS'">
            <!-- <input class="" type="text" style="float:left;width:60%;height:38px;" v-model="campaignName"/> -->
            <!-- <el-input type="text" v-model="campaignName" placeholder="搜尋..." prefix-icon="el-icon-search" style="float:left;width: 80%"></el-input> -->
            <form class="d-flex" style="margin: 10px 0px 10px 3px;" onkeypress="return event.keyCode != 13">
              <!--input class="form-control me-1" type="search" placeholder="請輸入 MMS 範本名稱" aria-label="Search"
                        style="width:50%;">
                      <button class="btn btn-dark" type="button"
                        style="width:4%;background-color:#9D9D9D;border: 1px solid #9D9D9D;">
                        <font-awesome-icon icon="a-solid fa-magnifying-glass" style="font-size: 13px;margin-bottom: 2px;" />
                      </button-->
              <div class="d-flex flex-row position-relative" style="width:50%;">
                <input type="text" class="form-control" id="example-search-input" v-model="searchName"
                  placeholder="請輸入 MMS 範本名稱" v-on:keyup="keyUpFun">
                <button class="btn border-0 position-absolute end-0" type="button" v-on:click="getListData">
                  <font-awesome-icon icon="a-solid fa-magnifying-glass" />
                </button>
              </div>
              <span style="width:36%;">&nbsp;</span>
              <button type="button" class="btn btn-light"
                style="width:15%;background-color:#fff;color:#2C70CB;border: 1px solid #cccccc;font-weight: 500;"
                v-on:click="selectModel('新增')">+ 新增 MMS 範本</button>
            </form>
            <div v-show="true" style="height:calc(100% - 20px);padding: 10px 0px;">
              <div id="tableList" style="height: calc(100%);">
                <el-table class="elTable" v-loading="listLoading" v-bind:data="showMmsList" element-loading-text="Loading"
                  v-bind:header-cell-style="{ background: '#FFF', color: '#606266', borderBottom: '1px solid #CCCCCC' }"
                  min-height="100%" style="width:100%;height: 100%;overflow: auto;">
                  <el-table-column prop="Name" label="MMS 範本" min-width="55%">
                    <template slot-scope="mms">
                      <span v-text="mms.row.AutoName">
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="Subject" label="簡訊主旨" min-width="15%">
                    <template slot-scope="mms">
                      <span v-text="mms.row.Subject">
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="CreatedAt" label="建立日期" min-width="15%">
                    <template slot-scope="mms">
                      <span v-text="mms.row.CreatedAt">
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="動作" min-width="15%">
                    <template slot-scope="scope">
                      <el-button v-on:click="selectModel('複製', scope.row)" type="text" size="small">Copy</el-button>
                      <el-button v-on:click="selectModel('編輯', scope.row)" type="text" size="small">Edit</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <el-pagination v-on:size-change="handleSizeChange1" v-on:current-change="handleCurrentChange1"
                v-bind:current-page="currentListPage" v-bind:pager-count="11" v-bind:total="total"
                layout="->, prev, pager, next" style="height:40px;padding:10px 0px 0px 0px;">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div v-show="selectedMsgType == 'SMS' && !isMainPage && isSSO == true">
      <div class="warp">
        <div class="innerWarp">
          <div class="titleDiv">
            <h3 class="titleText">{{ selectedMode }}SMS範本
              <div class="infoDiv" data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="right"
                title="若此範本已使用在已啟動的Journey內，再修改此範本的文案，不會同步更新Journey內的範本">
                <font-awesome-icon icon="fa-solid fa-circle-info" style="font-size: 13px;margin-bottom: 2px;" />
              </div>
            </h3>
          </div>

          <div class="Content">
            <div class="form-group contentLeft required">
              <label class="descLabel">編輯文案內容</label>
              <div>
                <label class="allLabel control-label">範本名稱</label>
                <label>(註：名稱一旦儲存後即不可修改)</label>
                <div class="infoDiv" data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="儲存後的名稱會自動代入_YYMMDD<br>例如：你的火鍋經營夥伴_221225">
                  <font-awesome-icon icon="fa-solid fa-circle-info" style="font-size: 13px;" />
                </div>
              </div>
              <input type="text" v-show="selectedMode == '編輯'" v-bind:class="[{ 'form-control': true }]"
                v-model="smsModel.AutoName" placeholder="請輸入範本名稱 ( 例如：你的火鍋經營夥伴)" v-bind:disabled="selectedMode == '編輯'" />
              <input type="text" v-show="selectedMode == '新增' || selectedMode == '複製'"
                v-bind:class="[{ 'form-control': true }, { 'is-invalid': this.smsNameError != '' }]"
                v-model="smsModel.Name" placeholder="請輸入範本名稱 ( 例如：你的火鍋經營夥伴)" />
              <div v-show="this.smsNameError != ''" class="invalid-feedback">
                {{ smsNameError }}
              </div>
              <div>
                <label class="allLabel control-label">內文</label>
                <div class="infoDiv" data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="註一：請在輸入URL的結尾處輸入半形空格，系統會自動抓取內文中的「https: ~ 半形空格」之間的URL到右側的URL欄位中。有被抓取的URL，最後會產出短網址。<br>註二：字數已依短網址計算">
                  <font-awesome-icon icon="fa-solid fa-circle-info" style="font-size: 13px;" />
                </div>
              </div>
              <textarea type="text"
                v-bind:class="[{ 'form-control': true }, { 'inputArea': true }, { 'is-invalid': this.smsContentError != '' }]"
                v-model="smsModel.Content" placeholder="請輸入內文"></textarea>
              <div style="display: flex;">
                <div style="width: 50%;">
                  <textarea style="display: none;" type="text" class="is-invalid"></textarea>
                  <label v-show="this.smsContentError != ''" class="invalid-feedback">
                    {{ smsContentError }}
                  </label>
                  <!--label v-if="this.smsContentError != ''" style="color: #D9432D;" class="allLabel">{{smsContentError}}</label-->
                </div>
                <label style="width: 50%;"
                  v-bind:class="[{ 'counter': true }, { 'errorLabel': this.smsModel.ContentLength > 70 }]">{{
                    'Counts:' + smsModel.ContentLength + ' / 70 Messages:' +
                    this.smsModel.Message
                  }}</label>
              </div>
            </div>

            <div class="form-group contentRight">
              <label class="descLabel">檢查區域(註：請使用右側顯示的長網址，檢查左側輸入的長網址是否正確)</label>
              <label class="allLabel">URL1</label>
              <input type="text" class="form-control" v-model="smsModel.URL1" disabled />
              <label class="allLabel">URL2</label>
              <input type="text" class="form-control" v-model="smsModel.URL2" disabled />
              <label class="allLabel">URL3</label>
              <input type="text" class="form-control" v-model="smsModel.URL3" disabled />
              <label class="allLabel">URL4</label>
              <input type="text" class="form-control" v-model="smsModel.URL4" disabled />
              <label class="allLabel">URL5</label>
              <input type="text" class="form-control" v-model="smsModel.URL5" disabled />
            </div>
          </div>

          <div class="bottom">
            <input type="button" value="Cancel" v-on:click="backToList()" class="cancelBtn" />
            <input type="button" value="Save" v-on:click="saveResult()" class="btn btn-primary saveBtn" />
          </div>
        </div>
      </div>
    </div>
    <div v-show="selectedMsgType == 'MMS' && !isMainPage && isSSO == true">
      <div class="warp">
        <div class="innerWarp">
          <div class="titleDiv">
            <h3 class="titleText">{{ selectedMode }}MMS範本
              <div class="infoDiv" data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="right"
                title="若此範本已使用在已啟動的Journey內，再修改此範本的文案，不會同步更新Journey內的範本">
                <font-awesome-icon icon="fa-solid fa-circle-info" style="font-size: 13px;margin-bottom: 2px;" />
              </div>
            </h3>
          </div>

          <div class="Content">
            <div class="form-group contentLeft required">
              <label class="descLabel">編輯文案內容</label>

              <div>
                <label class="allLabel control-label">範本名稱</label>
                <label>(註：名稱一旦儲存後即不可修改)</label>
                <div class="infoDiv" data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="儲存後的名稱會自動代入_YYMMDD<br>例如：你的火鍋經營夥伴_221225">
                  <font-awesome-icon icon="fa-solid fa-circle-info" style="font-size: 13px;" />
                </div>
              </div>
              <input type="text" v-show="selectedMode == '編輯'" v-bind:class="[{ 'form-control': true }]"
                v-model="mmsModel.AutoName" placeholder="請輸入範本名稱 ( 例如：你的火鍋經營夥伴)" v-bind:disabled="selectedMode == '編輯'" />
              <input type="text" v-show="selectedMode == '新增' || selectedMode == '複製'"
                v-bind:class="[{ 'form-control': true }, { 'is-invalid': this.mmsNameError != '' }]"
                v-model="mmsModel.Name" placeholder="請輸入範本名稱 ( 例如：你的火鍋經營夥伴)" />
              <div v-show="this.mmsNameError != ''" class="invalid-feedback">
                {{ mmsNameError }}
              </div>

              <div>
                <label class="allLabel control-label">簡訊主旨</label>
                <label>(註：中英文限制 15 字)</label>
              </div>
              <input type="text" v-bind:class="[{ 'form-control': true }, { 'is-invalid': this.mmsSubjectError != '' }]"
                v-model="mmsModel.Subject" placeholder="請輸入簡訊主旨" />
              <div v-show="this.mmsSubjectError != ''" class="invalid-feedback">
                {{ mmsSubjectError }}
              </div>

              <div>
                <label class="allLabel control-label">圖片</label>
                <div class="infoDiv" data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="僅支援png, jpg, jpeg, gif格式">
                  <font-awesome-icon icon="fa-solid fa-circle-info" style="font-size: 13px;" />
                </div>
              </div>
              <div class="row">
                <div class="col-sm-2">
                  <input type="button" value="Upload" v-on:click="$refs.file.click()" class="btn btn-primary" />
                </div>
                <input ref="file" type="file" style="display: none;" v-on:change="handleFileUpload()"
                  accept=".jpg, .jpeg, .png, .gif" />
                <div class="col-sm">
                  <input type="text" class="form-control" v-model="mmsModel.FigureName" placeholder="上傳圖片"
                    disabled="disabled" />
                </div>
              </div>
              <div class="progress" style="margin-top: 5px;">
                <div class="progress-bar" role="progressbar" aria-label="Basic example" aria-valuenow="0" v-bind:style="{width: uploadBarValue}"
                  aria-valuemin="0" aria-valuemax="100"></div>
              </div>
              <div style="display: flex;">
                <div style="width: 50%;display: block;">
                  <textarea style="display: none;" type="text" class="is-invalid"></textarea>
                  <div v-show="this.mmsImgError != ''" class="invalid-feedback" style="width: 50%;">
                    {{ mmsImgError }}
                  </div>
                </div>
                <div style="width: 50%;text-align: right;">
                  <label v-bind:class="[{ 'counter': true }, { 'errorLabel': this.mmsModel.FigrueLength > 295 }]">{{
                    'Figure Size:' + mmsModel.FigrueLength + 'KB' + ' / 295KB'
                  }}</label>
                </div>
              </div>

              <div>
                <label class="allLabel control-label">內文</label>
                <div class="infoDiv" data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="註一：請在輸入URL的結尾處輸入半形空格，系統會自動抓取內文中的「https: ~ 半形空格」之間的URL到右側的URL欄位中。有被抓取的URL，最後會產出短網址。<br>註二：字數已依短網址計算">
                  <font-awesome-icon icon="fa-solid fa-circle-info" style="font-size: 13px;" />
                </div>
              </div>
              <textarea type="text"
                v-bind:class="[{ 'form-control': true }, { 'inputArea': true }, { 'is-invalid': this.mmsContentError != '' }]"
                v-model="mmsModel.Content" placeholder="請輸入內文"></textarea>
              <div style="display: flex;">
                <div style="width: 50%;">
                  <textarea style="display: none;" type="text" class="is-invalid"></textarea>
                  <label v-show="this.mmsContentError != ''" class="invalid-feedback">
                    {{ mmsContentError }}
                  </label>
                  <!--label v-if="this.smsContentError != ''" style="color: #D9432D;" class="allLabel">{{smsContentError}}</label-->
                </div>
                <div style="display: flex;flex-direction: column;text-align: right;width: 50%;">
                  <label
                    v-bind:class="[{ 'counter': true }, { 'errorLabel': mmsModel.ContentLength + mmsModel.SubjectSize > 5 }]">{{
                      'Content Size:' + (mmsModel.ContentLength + mmsModel.SubjectSize) + 'KB' + ' / 5KB'
                    }}</label>
                  <label
                    v-bind:class="[{ 'counter': true }, { 'errorLabel': (mmsModel.FigrueLength + mmsModel.ContentLength + mmsModel.SubjectSize) > 300 }]">{{
                      'Total Size:' + (mmsModel.FigrueLength + mmsModel.ContentLength + mmsModel.SubjectSize) + 'KB' + '/'
                    + '300KB'
                    }}</label>
                </div>
              </div>
            </div>

            <div class="form-group contentRight">
              <label class="descLabel">檢查區域(註：請使用右側顯示的長網址，檢查左側輸入的長網址是否正確)</label>
              <label class="allLabel">URL1</label>
              <input type="text" class="form-control" v-model="mmsModel.URL1" disabled />
              <label class="allLabel">URL2</label>
              <input type="text" class="form-control" v-model="mmsModel.URL2" disabled />
              <label class="allLabel">URL3</label>
              <input type="text" class="form-control" v-model="mmsModel.URL3" disabled />
              <label class="allLabel">URL4</label>
              <input type="text" class="form-control" v-model="mmsModel.URL4" disabled />
              <label class="allLabel">URL5</label>
              <input type="text" class="form-control" v-model="mmsModel.URL5" disabled />
            </div>
          </div>

          <div class="bottom">
            <input type="button" value="Cancel" v-on:click="backToList()" class="cancelBtn" />
            <input type="button" value="Save" v-on:click="saveResult()" class="btn btn-primary saveBtn" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { doAuth, doAuth2 } from '@/api/authorized'
// eslint-disable-next-line no-unused-vars
import { getMsgList, getListByName, getOneById, insertListById, getOneByUniqueName } from '../api/messageTemplate.js'

// import request from '@/api/request'
export default {
  Name: 'MessageTemplate',
  data: function () {
    return {
      pageLoading: true,
      msg: 'Hi',
      isMainPage: true,
      modalType: '',
      selectedMode: '',
      selectedMsgType: 'SMS',
      listLoading: false,
      currentListPage: 1,
      pageSize: 11,
      total: 0,
      pageCount: 0,
      searchName: '',
      errMsgs: [],
      uploadBarValue: '0%',
      allSmsData: [{
        Name: 'test1',
        Content: 'hihi',
        URL1: '',
        URL2: '',
        URL3: '',
        URL4: '',
        URL5: '',
        ContentLength: 0,
        AutoName: 'test1',
        Message: 1,
        CreatedAt: '2022/12/25'
      }],
      showSmsList: [],
      smsNameError: '',
      smsContentError: '',
      smsModel: {
        Name: '',
        Content: '',
        URL1: '',
        URL2: '',
        URL3: '',
        URL4: '',
        URL5: '',
        ContentLength: 0,
        AutoName: '',
        Message: 0,
        Counte: 0,
        CreatedAt: '',
        tmpContent: ''
      },
      allMmsData: [{
        Name: '123',
        Subject: 'hihihi',
        Figure: '',
        FigureName: '',
        Content: '',
        URL1: '',
        URL2: '',
        URL3: '',
        URL4: '',
        URL5: '',
        CreatedAt: '2023/01/20'
      }],
      showMmsList: [],
      mmsNameError: '',
      mmsSubjectError: '',
      mmsImgError: '',
      mmsContentError: '',
      mmsModel: {
        Name: '',
        Subject: '',
        SubjectSize: 0,
        Figure: '',
        FigureName: '',
        FigrueLength: 0,
        Content: '',
        ContentLength: 0,
        URL1: '',
        URL2: '',
        URL3: '',
        URL4: '',
        URL5: '',
        AutoName: ''
      },
      // SSO
      isSSO: false,
      host: '',
      redirectPage: '',
      code: null,
      redirectUrl: '',
      pageName: 'messageTemplate',
      token: '',
      refreshToken: ''
    }
  },
  watch: {
    'smsModel.Content': function (val, oldVal) {
      this.splitUrls('SMS')
      this.reCalcSmsLength()
    },
    'mmsModel.Content': function (val, oldVal) {
      this.splitUrls('MMS')
      this.reCalcMmsLength()
    },
    'mmsModel.Subject': function (val, oldVal) {
      this.reCalcMmsSubjectLength()
    }
  },
  created () {
    this.host = process.env.VUE_SERVER_DOMAIN
    this.redirectPage = this.$route.query.redirect == undefined ? 'messageTemplate' : this.$route.query.redirect;
    if (this.redirectPage == null && this.code == null) {
      alert('登錄資訊錯誤');
      return;
    }

    this.redirectUrl = "https://" + this.host + "/messageTemplate?redirect=" + this.redirectPage.replace("/", "")
    this.code = this.$route.query.code == undefined ? 0 : this.$route.query.code;
    
    if (this.code != 0) {
      let req = {
        page: this.redirectPage,
        code: this.code,
        redirect_uri: this.redirectUrl
      };
      doAuth2(req).then(res => {
        if (res.Success) {
          if (res.AccessToken) {
            //this.$store.dispatch("resetToken", res.AccessToken.access_token);
            //this.$store.dispatch("resetRefreshToken", res.AccessToken.refresh_token);
            this.token = res.AccessToken.access_token;
            this.refreshToken = res.AccessToken.refresh_token;
            this.isSSO = true;
            this.$router.push(this.redirectPage).catch(() => {});
            this.getListData()
            this.pageLoading = false;
          }
        }
      });
    } else if (this.redirectPage != null && this.code == 0) {
      let req = {
        page: this.redirectPage
      };

      doAuth(req).then(res => {
        if (res.Success) {
          let targetUrl = res.TargetUrl.replace(
            "{{redirect_url}}",
            this.redirectUrl
          );
          window.location.href = targetUrl
        }
      });
    }
  },
  mounted: function () {
    this.initTooltip()
    //this.getListData()
    // this.currentChangePage(this.allSmsData, this.currentListPage)
    // this.currentChangePage(this.allMmsData, this.currentListPage)
  },
  methods:
  {
    initTooltip: function () {
      this.$nextTick(function () {
        var tooltipTriggerList = [].slice.call(
          document.querySelectorAll('[data-bs-toggle="tooltip"]')
        )
        // eslint-disable-next-line no-unused-vars
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
          // eslint-disable-next-line no-undef
          return new bootstrap.Tooltip(tooltipTriggerEl)
        })
      })
    },
    switchMsgType: function () {
      this.searchName = ''
      this.getListData()
    },
    getListData: function () {

      this.listLoading = true

      // 搜尋欄位有值的話需要用名稱模糊搜尋
      if (this.selectedMsgType !== '' && this.searchName !== '') {
        let req = {}
        req.pageName = this.pageName
        req.token = this.token
        req.refreshToken = this.refreshToken
        getListByName(req, this.selectedMsgType, this.searchName).then((success) => {
          //token
          this.token =  success.token.access_token
          this.refreshToken =  success.token.refresh_token
          //資料
          for (let i = 0; i < success.dataList.length; i++) {
            let tmpRes = success.dataList[i]
            tmpRes.CreatedAt = tmpRes.CreatedAt.substring(0, tmpRes.CreatedAt.indexOf('T'))
            tmpRes.CreatedAt = tmpRes.CreatedAt.replaceAll('-', '/')
            this.allSmsData.push(tmpRes)
          }
          this.total = success.dataList.length - 1
          this.allSmsData = success.dataList
          this.currentListPage = 1
          this.currentChangePage(this.allSmsData, this.currentListPage)
          this.listLoading = false
        }, (fail) => {
          console.log(fail)
          this.listLoading = false
        })
      } else {
        // call api取前55筆資料
        let req = {}
        req.pageName = this.pageName
        req.token = this.token
        req.refreshToken = this.refreshToken
        getMsgList(req, this.selectedMsgType).then((success) => {
          //token
          this.token =  success.token.access_token
          this.refreshToken =  success.token.refresh_token
          //資料
          for (let i = 0; i < success.dataList.length; i++) {
            let tmpRes = success.dataList[i]
            tmpRes.CreatedAt = tmpRes.CreatedAt.substring(0, tmpRes.CreatedAt.indexOf('T'))
            tmpRes.CreatedAt = tmpRes.CreatedAt.replaceAll('-', '/')
            this.allSmsData.push(tmpRes)
          }
          this.total = success.dataList.length - 1
          this.currentListPage = 1
          if (this.selectedMsgType === 'SMS') {
            this.allSmsData = success.dataList
            this.currentChangePage(this.allSmsData, this.currentListPage)
          } else if (this.selectedMsgType === 'MMS') {
            this.allMmsData = success.dataList
            this.currentChangePage(this.allMmsData, this.currentListPage)
          }
          this.listLoading = false
        }, (fail) => {
          console.log(fail)
          this.listLoading = false
        })
      }
    },
    handleClick: function (tab, event) {
    },
    selectMsgType: function (type) {
      // this.isMainPage = false
      this.listLoading = true
      this.selectedMsgType = type
      this.listLoading = false
    },
    selectModel: function (model, data) {
      this.isMainPage = false
      this.selectedMode = model
      if (this.selectedMsgType === 'SMS' && model === '新增') {
        this.smsModel = {
          Name: '',
          Content: '',
          URL1: '',
          URL2: '',
          URL3: '',
          URL4: '',
          URL5: '',
          ContentLength: 0,
          AutoName: '',
          Message: 0,
          Counte: 0,
          CreatedAt: '',
          tmpContent: ''
        }
      } else if (this.selectedMsgType === 'SMS' && (model === '編輯' || model === '複製')) {
        this.smsModel = data
        this.restoreSmsUrl()
        this.reCalcSmsLength()
        // this.smsModel.ContentLength = this.smsModel.Content.length
        if (model === '複製') {
          this.smsModel.ID = null
          this.smsModel.Name = this.smsModel.Name += '_Copy'
        }
      } else if (this.selectedMsgType === 'MMS' && model === '新增') {
        this.mmsModel = {
          Name: '',
          Subject: '',
          SubjectSize: 0,
          Figure: '',
          FigureName: '',
          FigrueLength: 0,
          Content: '',
          ContentLength: 0,
          URL1: '',
          URL2: '',
          URL3: '',
          URL4: '',
          URL5: '',
          AutoName: ''
        }
      } else if (this.selectedMsgType === 'MMS' && (model === '編輯' || model === '複製')) {
        this.mmsModel = data
        this.restoreMmsUrl()
        this.reCalcMmsSubjectLength()
        this.reCalcMmsLength()
        this.mmsModel.FigrueLength = Math.ceil(this.dataURItoBlob(decodeURIComponent(this.mmsModel.Figure)).size / 1024)
        if (model === '複製') {
          this.mmsModel.ID = null
          this.mmsModel.Name = this.mmsModel.Name += '_Copy'
        }
      }

      this.initTooltip()
      // 設定預設值
    },
    handleSizeChange1: function (pageSize) {
      // 每頁條數切换
      this.pageSize = pageSize
      this.handleCurrentChange1(1)
    },
    handleCurrentChange1: function (currentPage) {
      // 頁碼切换
      this.currentListPage = currentPage
      if (this.selectedMsgType === 'SMS') {
        this.currentChangePage(this.allSmsData, this.currentListPage)
      } else if (this.selectedMsgType === 'MMS') {
        this.currentChangePage(this.allMmsData, this.currentListPage)
      }
    },
    // 分頁方法
    currentChangePage: function (tempList, currentPage) {
      let from = 0
      if (currentPage !== 1) {
        from = (currentPage - 1) * this.pageSize
      }
      let to = currentPage * this.pageSize
      if (this.selectedMsgType === 'SMS') {
        this.showSmsList = []
        for (; from < to; from++) {
          if (tempList[from]) {
            this.showSmsList.push(tempList[from])
          }
        }
      } else if (this.selectedMsgType === 'MMS') {
        this.showMmsList = []
        for (; from < to; from++) {
          if (tempList[from]) {
            this.showMmsList.push(tempList[from])
          }
        }
      }
    },
    backToList: function () {
      this.isMainPage = true
      this.selectedMode = ''
      // this.selectedMsgType = ''
      this.smsNameError = ''
      this.smsContentError = ''
      this.mmsNameError = ''
      this.mmsSubjectError = ''
      this.mmsImgError = ''
      this.mmsContentError = ''
      this.uploadBarValue = '0%'
      this.getListData()
    },
    saveResult: function () {
      if (this.selectedMsgType === 'SMS') {
        if (this.smsModel.Name === '') {
          this.smsNameError = '請填寫範本名稱'
        } else if (!this.checkContent(this.smsModel.Name)) {
          this.smsNameError = '範本名稱格式錯誤'
        } else {
          this.smsNameError = ''
        }

        if (this.smsModel.Content === '') {
          this.smsContentError = '請填寫內文'
        } else {
          this.smsContentError = ''
        }
        // 同範本名稱在新增或編輯時檢核，這邊先放行
        if ((this.smsNameError !== '' && this.smsNameError !== '已存在相同範本名稱，請重新輸入') || this.smsContentError !== '') {
          return null
        }

        if (this.selectedMode === '新增' || this.selectedMode === '複製') {
          this.insertSms()
        } else if (this.selectedMode === '編輯') {
          this.editSms()
        }
      } else if (this.selectedMsgType === 'MMS') {
        if (this.mmsModel.Name === '') {
          this.mmsNameError = '請填寫範本名稱'
        } else if (!this.checkContent(this.mmsModel.Name)) {
          this.mmsNameError = '範本名稱格式錯誤'
        } else {
          this.mmsNameError = ''
        }

        if (this.mmsModel.Content === '') {
          this.mmsContentError = '請填寫內文'
        } else {
          this.mmsContentError = ''
        }

        if (this.mmsModel.Subject === '') {
          this.mmsSubjectError = '請輸入簡訊主旨'
        } else if (!this.checkContent(this.mmsModel.Subject)) {
          this.mmsSubjectError = '簡訊主旨格式錯誤'
        } else if (this.mmsModel.Subject.length > 15) {
          this.mmsSubjectError = '簡訊主旨長度不能大於15'
        }else {
          this.mmsSubjectError = ''
        }

        if (this.mmsModel.Figure === '') {
          this.mmsImgError = '請上傳圖片'
        }

        if (this.mmsModel.FigrueLength > 295) {
          let errMsgs = []
          errMsgs.push('此MMS的圖片尺寸超過295KB，因此無法儲存')
          this.modalType = 'error'
          this.showModal(errMsgs)
          return null
        } else if (this.mmsModel.ContentLength + this.mmsModel.SubjectSize > 5) {
          let errMsgs = []
          errMsgs.push('此MMS的內文超過5KB，因此無法儲存')
          this.modalType = 'error'
          this.showModal(errMsgs)
          return null
        } else if (this.mmsModel.FigrueLength + this.mmsModel.ContentLength + this.mmsModel.SubjectSize > 300) {
          let errMsgs = []
          errMsgs.push('此MMS的總容量超過300KB，因此無法儲存')
          this.modalType = 'error'
          this.showModal(errMsgs)
          return null
        }

        // 同範本名稱在新增或編輯時檢核，這邊先放行
        if ((this.mmsNameError !== '' && this.mmsNameError !== '已存在相同範本名稱，請重新輸入') || this.mmsContentError !== '' || this.mmsSubjectError !== '' || this.mmsImgError !== '') {
          return null
        }

        if (this.selectedMode === '新增' || this.selectedMode === '複製') {
          this.insertMms()
        } else if (this.selectedMode === '編輯') {
          this.editMms()
        }
      }
    },
    insertSms: function () {
      let requestModel = this.getSmsRequestModel(this.smsModel)
      let req = {}
      req.pageName = this.pageName
      req.token = this.token
      req.refreshToken = this.refreshToken
      let tmpSmsRes = getOneByUniqueName(req, requestModel.UniqueName)
      tmpSmsRes.then((success) => {
        //token
        this.token =  success.token.access_token
        this.refreshToken =  success.token.refresh_token
        //資料
        if (success.dataList.UniqueName === '') {
          let tmReq = []
          tmReq.push(requestModel)
          this.upsertSmsAndLockName(tmReq)
          this.smsNameError = ''
        } else {
          this.smsNameError = '已存在相同範本名稱，請重新輸入'
        }
      }, (fail) => {
        console.log(fail)
      })
    },
    editSms: function () {
      let requestModel = this.getSmsRequestModel(this.smsModel)
      requestModel.AutoName = this.smsModel.AutoName
      requestModel.UniqueName = this.smsModel.AutoName + '_SMS'
      let tmReq = []
      tmReq.push(requestModel)
      this.upsertSmsAndLockName(tmReq)
      this.smsNameError = ''
    },
    upsertSmsAndLockName: function (tmReq) {
      let req = {}
      req.data = tmReq
      req.pageName = this.pageName
      req.token = this.token
      req.refreshToken = this.refreshToken
      let res = insertListById(req)
      res.then((success) => {
        if (success.dataList.Data.length > 0) {
          // this.smsModel = success[0]
          this.smsModel.AutoName = success.dataList.Data[0].AutoName
          this.smsModel.ID = success.dataList.Data[0].ID
          this.selectedMode = '編輯'
          let errMsgs = []
          errMsgs.push('儲存成功！請注意：若有已啟動的 Journey 使用此文案，推送內容會因為修改而有所不同。')
          this.modalType = 'toMainPage'
          this.showModal(errMsgs)
          this.getListData()
        }
      }, (fail) => {
        console.log(fail)
      })
    },
    insertMms: function () {
      let requestModel = this.getMmsRequestModel(this.mmsModel)
      let req = {}
      req.pageName = this.pageName
      req.token = this.token
      req.refreshToken = this.refreshToken
      let tmpMmsRes = getOneByUniqueName(req, requestModel.UniqueName)
      tmpMmsRes.then((success) => {
         //token
        this.token =  success.token.access_token
        this.refreshToken =  success.token.refresh_token
        //資料
        if (success.dataList.UniqueName === '') {
          let tmReq = []
          tmReq.push(requestModel)
          this.upsertMmsAndLockName(tmReq)
          this.mmsNameError = ''
        } else {
          this.mmsNameError = '已存在相同範本名稱，請重新輸入'
        }
      }, (fail) => {
        console.log(fail)
      })
    },
    editMms: function () {
      let requestModel = this.getMmsRequestModel(this.mmsModel)
      requestModel.AutoName = this.mmsModel.AutoName
      requestModel.UniqueName = this.mmsModel.AutoName + '_MMS'
      let tmReq = []
      tmReq.push(requestModel)
      this.upsertMmsAndLockName(tmReq)
      this.mmsNameError = ''
    },
    upsertMmsAndLockName: function (tmReq) {
      let req = {}
      req.data = tmReq
      req.pageName = this.pageName
      req.token = this.token
      req.refreshToken = this.refreshToken
      let res = insertListById(req)
      res.then((success) => {
        if (success.dataList.Data.length > 0) {
          // this.smsModel = success[0]
          this.mmsModel.AutoName = success.dataList.Data[0].AutoName
          this.mmsModel.ID = success.dataList.Data[0].ID
          this.selectedMode = '編輯'
          let errMsgs = []
          errMsgs.push('儲存成功！請注意：若有已啟動的 Journey 使用此文案，推送內容會因為修改而有所不同。')
          this.modalType = 'toMainPage'
          this.showModal(errMsgs)
          this.getListData()
        }
      }, (fail) => {
        console.log(fail)
      })
    },
    splitUrls: function (type) {
      if (type === 'SMS') {
        this.$set(this.smsModel, 'URL1', '')
        this.$set(this.smsModel, 'URL2', '')
        this.$set(this.smsModel, 'URL3', '')
        this.$set(this.smsModel, 'URL4', '')
        this.$set(this.smsModel, 'URL5', '')
        if (!this.smsModel.Content.includes('https')) {
          return
        }
        let procStr = this.smsModel.Content
        let count = 1
        while (procStr.includes('https') && count < 6) {
          procStr = procStr.substring(procStr.indexOf('https'))

          let tmpStartIndex = procStr.indexOf('https')
          let tmpEndIndex = procStr.indexOf(' ')
          if (tmpEndIndex === -1) {
            tmpEndIndex = procStr.length
          }

          let tmpStr = procStr.substring(tmpStartIndex, tmpEndIndex)
          if (count === 1) {
            this.$set(this.smsModel, 'URL1', tmpStr)
          } else if (count === 2) {
            this.$set(this.smsModel, 'URL2', tmpStr)
          } else if (count === 3) {
            this.$set(this.smsModel, 'URL3', tmpStr)
          } else if (count === 4) {
            this.$set(this.smsModel, 'URL4', tmpStr)
          } else if (count === 5) {
            this.$set(this.smsModel, 'URL5', tmpStr)
          }

          procStr = procStr.replace(tmpStr, '')
          count++
        }
      } else if (type === 'MMS') {
        this.$set(this.mmsModel, 'URL1', '')
        this.$set(this.mmsModel, 'URL2', '')
        this.$set(this.mmsModel, 'URL3', '')
        this.$set(this.mmsModel, 'URL4', '')
        this.$set(this.mmsModel, 'URL5', '')
        if (!this.mmsModel.Content.includes('https')) {
          return
        }
        let procStr = this.mmsModel.Content
        let count = 1
        while (procStr.includes('https') && count < 6) {
          procStr = procStr.substring(procStr.indexOf('https'))

          let tmpStartIndex = procStr.indexOf('https')
          let tmpEndIndex = procStr.indexOf(' ')
          if (tmpEndIndex === -1) {
            tmpEndIndex = procStr.length
          }

          let tmpStr = procStr.substring(tmpStartIndex, tmpEndIndex)
          if (count === 1) {
            this.$set(this.mmsModel, 'URL1', tmpStr)
          } else if (count === 2) {
            this.$set(this.mmsModel, 'URL2', tmpStr)
          } else if (count === 3) {
            this.$set(this.mmsModel, 'URL3', tmpStr)
          } else if (count === 4) {
            this.$set(this.mmsModel, 'URL4', tmpStr)
          } else if (count === 5) {
            this.$set(this.mmsModel, 'URL5', tmpStr)
          }

          procStr = procStr.replace(tmpStr, '')
          count++
        }
      }
    },
    restoreSmsUrl: function () {
      if (this.smsModel.URL1 !== '') {
        this.smsModel.Content = this.smsModel.Content.replace('{{!URL1}}', this.smsModel.URL1)
      }
      if (this.smsModel.URL2 !== '') {
        this.smsModel.Content = this.smsModel.Content.replace('{{!URL2}}', this.smsModel.URL2)
      }
      if (this.smsModel.URL3 !== '') {
        this.smsModel.Content = this.smsModel.Content.replace('{{!URL3}}', this.smsModel.URL3)
      }
      if (this.smsModel.URL4 !== '') {
        this.smsModel.Content = this.smsModel.Content.replace('{{!URL4}}', this.smsModel.URL4)
      }
      if (this.smsModel.URL5 !== '') {
        this.smsModel.Content = this.smsModel.Content.replace('{{!URL5}}', this.smsModel.URL5)
      }
    },
    restoreMmsUrl: function () {
      if (this.mmsModel.URL1 !== '') {
        this.mmsModel.Content = this.mmsModel.Content.replace('{{!URL1}}', this.mmsModel.URL1)
      }
      if (this.mmsModel.URL2 !== '') {
        this.mmsModel.Content = this.mmsModel.Content.replace('{{!URL2}}', this.mmsModel.URL2)
      }
      if (this.mmsModel.URL3 !== '') {
        this.mmsModel.Content = this.mmsModel.Content.replace('{{!URL3}}', this.mmsModel.URL3)
      }
      if (this.mmsModel.URL4 !== '') {
        this.mmsModel.Content = this.mmsModel.Content.replace('{{!URL4}}', this.mmsModel.URL4)
      }
      if (this.mmsModel.URL5 !== '') {
        this.mmsModel.Content = this.mmsModel.Content.replace('{{!URL5}}', this.mmsModel.URL5)
      }
    },
    reCalcSmsLength: function () {
      let tmpAllLength = this.smsModel.Content.length
      let tmpUrlLength = 0
      let newUrl = 0
      if (this.smsModel.URL1 !== undefined && this.smsModel.URL1 !='') {
        tmpUrlLength += this.smsModel.URL1.length
        newUrl += 1
      } if (this.smsModel.URL2 !== undefined && this.smsModel.URL2 !='') {
        tmpUrlLength += this.smsModel.URL2.length
        newUrl += 1
      } if (this.smsModel.URL3 !== undefined && this.smsModel.URL3 !='') {
        tmpUrlLength += this.smsModel.URL3.length
        newUrl += 1
      } if (this.smsModel.URL4 !== undefined && this.smsModel.URL4 !='') {
        tmpUrlLength += this.smsModel.URL4.length
        newUrl += 1
      } if (this.smsModel.URL5 !== undefined && this.smsModel.URL5 !='') {
        tmpUrlLength += this.smsModel.URL5.length
        newUrl += 1
      }

      if (tmpAllLength >= tmpUrlLength) {
        this.$set(this.smsModel, 'ContentLength', tmpAllLength - tmpUrlLength + (newUrl * 24)) // 0要換成短網址的長度加回去
      } else if (tmpAllLength === 0) {
        this.$set(this.smsModel, 'ContentLength', 0)
      }

      let tmpCount = Math.ceil(this.smsModel.ContentLength / 70)
      this.$set(this.smsModel, 'Message', tmpCount)
    },
    reCalcMmsLength: function () {
      let tmpAllLength = this.mmsModel.Content.length
      let tmpUrlLength = 0
      // let newUrl = 0
      // let tmpNewLength = 0
      if (this.mmsModel.URL1 !== undefined) {
        tmpUrlLength += this.mmsModel.URL1.length
        // newUrl += 1
      } if (this.mmsModel.URL2 !== undefined) {
        tmpUrlLength += this.mmsModel.URL2.length
        // newUrl += 1
      } if (this.mmsModel.URL3 !== undefined) {
        tmpUrlLength += this.mmsModel.URL3.length
        // newUrl += 1
      } if (this.mmsModel.URL4 !== undefined) {
        tmpUrlLength += this.mmsModel.URL4.length
        // newUrl += 1
      } if (this.mmsModel.URL5 !== undefined) {
        tmpUrlLength += this.mmsModel.URL5.length
        // newUrl += 1
      }
      if (tmpAllLength > tmpUrlLength) {
        // let tmpNewLength = tmpAllLength - tmpUrlLength + (newUrl * 0) // 0要換成短網址的長度加回去
        // this.$set(this.mmsModel, 'ContentLength', tmpAllLength - tmpUrlLength + (newUrl * 0)) // 0要換成短網址的長度加回去
        let contentSize = this.getStringSize(this.mmsModel.Content)
        this.$set(this.mmsModel, 'ContentLength', contentSize)
      } else if (tmpAllLength === 0) {
        this.$set(this.mmsModel, 'ContentLength', 0)
      }

      // let tmpCount = Math.ceil(this.mmsModel.ContentLength / 70)
      // this.$set(this.mmsModel, 'Message', tmpCount)
    },
    reCalcMmsSubjectLength: function () {
      let SubjectSize = this.getStringSize(this.mmsModel.Subject)
      this.$set(this.mmsModel, 'SubjectSize', SubjectSize)
    },
    getStringSize: function (value) {
      return Math.ceil((new Blob([value]).size) / 1024)
    },
    checkContent: function (value) {
      // let reg = /^[A-Za-z0-9\u4e00-\u9fa5]$/
      // eslint-disable-next-line no-useless-escape
      // let reg = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im
      // eslint-disable-next-line no-useless-escape
      let reg = /[`~!@#|$%^&*()+=<>\-?:"{}\\,.\/;'[\]]/im
      if (reg.test(value)) {
        return false
      } else {
        return true
      }
    },
    getSmsRequestModel: function (msgModel) {
      let tmpMsgModel = { ...msgModel }
      let tmpRequestModel = {}
      // content替換
      if (tmpMsgModel.URL1 !== '') {
        tmpMsgModel.Content = tmpMsgModel.Content.replace(tmpMsgModel.URL1, '{{!URL1}}')
      }
      if (tmpMsgModel.URL2 !== '') {
        tmpMsgModel.Content = tmpMsgModel.Content.replace(tmpMsgModel.URL2, '{{!URL2}}')
      }
      if (tmpMsgModel.URL3 !== '') {
        tmpMsgModel.Content = tmpMsgModel.Content.replace(tmpMsgModel.URL3, '{{!URL3}}')
      }
      if (tmpMsgModel.URL4 !== '') {
        tmpMsgModel.Content = tmpMsgModel.Content.replace(tmpMsgModel.URL4, '{{!URL4}}')
      }
      if (tmpMsgModel.URL5 !== '') {
        tmpMsgModel.Content = tmpMsgModel.Content.replace(tmpMsgModel.URL5, '{{!URL5}}')
      }

      // tmpMsgModel.Content = tmpMsgModel.Content.replaceAll('\r\n', '<br>')
      // tmpMsgModel.Content = tmpMsgModel.Content.replaceAll('\n', '<br>')

      let tmpDate = new Date().toLocaleString('zh-TW', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).replaceAll('/', '').substring(2, 8)

      tmpRequestModel.ID = tmpMsgModel.ID
      tmpRequestModel.Name = tmpMsgModel.Name
      tmpRequestModel.AutoName = tmpMsgModel.Name + '_' + tmpDate
      tmpRequestModel.UniqueName = tmpMsgModel.Name + '_' + tmpDate + '_SMS'
      tmpRequestModel.Type = 'SMS'
      tmpRequestModel.Content = tmpMsgModel.Content
      tmpRequestModel.URL1 = tmpMsgModel.URL1
      tmpRequestModel.URL2 = tmpMsgModel.URL2
      tmpRequestModel.URL3 = tmpMsgModel.URL3
      tmpRequestModel.URL4 = tmpMsgModel.URL4
      tmpRequestModel.URL5 = tmpMsgModel.URL5
      tmpRequestModel.Message = tmpMsgModel.Message
      return tmpRequestModel
    },
    getMmsRequestModel: function (msgModel) {
      let tmpMsgModel = { ...msgModel }
      let tmpRequestModel = {}
      // content替換
      if (tmpMsgModel.URL1 !== '') {
        tmpMsgModel.Content = tmpMsgModel.Content.replace(tmpMsgModel.URL1, '{{!URL1}}')
      }
      if (tmpMsgModel.URL2 !== '') {
        tmpMsgModel.Content = tmpMsgModel.Content.replace(tmpMsgModel.URL2, '{{!URL2}}')
      }
      if (tmpMsgModel.URL3 !== '') {
        tmpMsgModel.Content = tmpMsgModel.Content.replace(tmpMsgModel.URL3, '{{!URL3}}')
      }
      if (tmpMsgModel.URL4 !== '') {
        tmpMsgModel.Content = tmpMsgModel.Content.replace(tmpMsgModel.URL4, '{{!URL4}}')
      }
      if (tmpMsgModel.URL5 !== '') {
        tmpMsgModel.Content = tmpMsgModel.Content.replace(tmpMsgModel.URL5, '{{!URL5}}')
      }

      let tmpDate = new Date().toLocaleString('zh-TW', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).replaceAll('/', '').substring(2, 8)

      tmpRequestModel.ID = tmpMsgModel.ID
      tmpRequestModel.Name = tmpMsgModel.Name
      tmpRequestModel.AutoName = tmpMsgModel.Name + '_' + tmpDate
      tmpRequestModel.UniqueName = tmpMsgModel.Name + '_' + tmpDate + '_MMS'
      tmpRequestModel.Type = 'MMS'
      tmpRequestModel.Subject = tmpMsgModel.Subject
      tmpRequestModel.Content = tmpMsgModel.Content
      tmpRequestModel.Figure = tmpMsgModel.Figure
      tmpRequestModel.FigureName = tmpMsgModel.FigureName
      tmpRequestModel.URL1 = tmpMsgModel.URL1
      tmpRequestModel.URL2 = tmpMsgModel.URL2
      tmpRequestModel.URL3 = tmpMsgModel.URL3
      tmpRequestModel.URL4 = tmpMsgModel.URL4
      tmpRequestModel.URL5 = tmpMsgModel.URL5
      return tmpRequestModel
    },
    handleFileUpload: function () {
      this.mmsModel.Figure = ''
      this.mmsModel.FigureName = ''
      this.mmsModel.FigrueLength = 0
      this.mmsImgError = ''
      if (this.$refs.file.files[0] === null || this.$refs.file.files[0] === undefined) {
        return false
      }
      if (!this.validFileType(this.$refs.file.files[0])) {
        this.mmsImgError = '上傳的圖片僅支援png, jpg, jpeg, gif格式'
        this.$refs.file.value = null
        return null
      } else if (this.$refs.file.files[0] !== null) {
        // this.mmsModel.Figure = this.$refs.file.files[0]
        this.mmsModel.FigureName = this.$refs.file.files[0].name
        this.mmsModel.FigrueLength = Math.ceil(this.$refs.file.files[0].size / 1024)
        this.getBase64(this.$refs.file.files[0])
      }
    },
    validFileType: function (file) {
      return ['image/gif', 'image/jpeg', 'image/jpg', 'image/png'].includes(file.type)
    },
    // 將圖片轉換為Base64
    getBase64: function (file) {
      // let data = ''
      // let datas = ''
      let reader = new FileReader()
      reader.readAsDataURL(file)

      reader.onprogress = (e) => {
        let val = (e.loaded / file.size * 100) + '%'
        this.uploadBarValue = val
      }

      reader.onload = (e) => {
        // let data = reader.result.substring(reader.result.indexOf(',') + 1)
        let data = reader.result
        this.$set(this.mmsModel, 'Figure', encodeURIComponent(data))
      }
      reader.onerror = function (error) {
        console.log('Error: ', error)
      }
    },
    dataURItoBlob: function (dataURI) {
      let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      let byteString = atob(dataURI.split(',')[1])
      let arrayBuffer = new ArrayBuffer(byteString.length)
      let intArray = new Uint8Array(arrayBuffer)

      for (let i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i)
      }
      return new Blob([intArray], { type: mimeString })
    },
    showModal: function (errMsgs) {
      // eslint-disable-next-line no-undef
      const myModal = new bootstrap.Modal(document.getElementById('myModal'))
      this.errMsgs = errMsgs
      myModal.show()
    },
    keyUpFun: function(e) {
      if (e.keyCode === 13) {
        // console.log('Enter was pressed');
        if(this.selectedMsgType == 'SMS')
          this.getListData();
        else if(this.selectedMsgType == 'MMS')
          this.getListData();
      } else if (e.keyCode === 50) {
        // console.log('@ was pressed');
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loading {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: .5;
}

.spinner-border {
  margin-top: 30%;
  width: 5rem;
  height: 5rem;
}

.warp {
  display: flex;
  justify-Content: center;
  align-items: center;
  flex-direction: column;
}

.innerWarp {
  width: 1180px;
  border: 1px solid #E4E4E4;
  border-radius: 8px;
}

.titleDiv {
  border-bottom: 1px solid #E4E4E4;
}

.titleText {
  padding-top: 15px;
  padding-bottom: 15px;
  font-style: normal;
  font-weight: 510;
  font-size: 18px;
  line-height: 21px;
  margin-bottom: 0;
  text-align: left;
  margin-left: 23px;
}

.Content {
  display: flex;
  justify-Content: center;
  -webkit-box-align: center;
  margin-top: 25px;
  margin-bottom: 25px;
}

.contentLeft {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-right: 50px;
  width: 46%;
}

.counter {
  text-align: right;
  line-height: 30px;
}

.contentRight {
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 46%;
}

.inputArea {
  height: 150px;
}

.allLabel {
  line-height: 30px;
  margin-top: 15px;
}

.descLabel {
  font-family: 'PingFang TC';
  font-style: normal;
  font-weight: 1000;
}

.errorLabel {
  color: #D9432D;
}

.bottom {
  border-top: 1px solid #E4E4E4;
  padding-top: 15px;
  padding-bottom: 15px;
  line-height: 21px;
  text-align: right;
}

.saveBtn {
  margin-right: 20px;
  line-height: 21px;
}

.cancelBtn {
  margin-right: 20px;
  line-height: 21px;
  border: none;
  background: none;
  color: #0d6efd;
}

.infoDiv {
  display: inline;
}

.form-group.required .control-label:after {
  Content: "*";
  color: red;
  /*margin-left: -3px;*/
}</style>
